import { useState, useLayoutEffect } from 'react';

// Point-1 (chat header) — measure an element's live pixel height so sibling
// elements (pinned banner, message list) can offset by the header's ACTUAL
// height instead of a hardcoded assumption. Keeps the header WhatsApp-fixed and
// prevents content overflow/overlap when the header grows (long name + address).
export default function useElementHeight(ref, fallback = 0) {
  const [height, setHeight] = useState(fallback);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setHeight(el.offsetHeight || fallback);
    measure();
    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(measure);
      ro.observe(el);
    }
    window.addEventListener('resize', measure);
    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [ref, fallback]);
  return height;
}
